import React, { useRef, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import { Container, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faFilePdf, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import moment from "moment";
//Rotas
import routes from "../routes.js";
//Helpers
import { getSessionCookie } from "../helpers/cookies.js";
import { showMessage } from "../helpers/message.js";

//Api
import setup_api from '../api/setup_api';

//Context
import { useAuth } from "../context/auth.js";

export default function Empty() {
  const { setupVariavel } = useAuth();

  //Variavel de navegação
  const navigate = useNavigate();
  //Variavel para pegar os dados passados por rota
  const location = useLocation();
  //Variaveis pegas na rota
  const {
    pdf, xls, title, initialDate, finalDate, tipoMapa, agrupamento, modalidadeColeta, gerador,
    transportador, destinoFinal, ramoAtividade, localidades, regional, status, cidades, idMTR, statusMTR, filtros, rotaVoltar
  } = location.state;
  //Referencia para o componente de impressão
  const ref = useRef(null);
  //usuario logado no sistema
  const usuario = getSessionCookie();
  //Estilo da pagina de impressão
  const pageStyle = `
  @page { 
    size: auto;  margin: 0mm ;
  } 
  @media print { 
      body { -webkit-print-color-adjust: exact; } 
  }
  @media print {
    @page{
      size:A4;
      margin:0;
    }
    .relatorio {
      width: 100vw!important;
      display:flex;
      flex-direction:column;
    }
    div.header{
      display:table-header-group;
    }
    div.body{
      display:table-row-group;
      line-height: normal;
    }
    div.body h1 {
      font-size: 16pt;
    }

  }
  `;
  
  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    copyStyles: true,
    documentTitle: title,
    pageStyle: pageStyle
  });

  return (
    <div className="content-login">
      <Container className="margin-auth shadow pt-4 h-100 overflow-scroll" >
        <div className="mb-4  d-flex align-items-center justify-content-between">
          <Button onClick={() => navigate(rotaVoltar ? rotaVoltar : -1, {
            state: {
              filtros: filtros
            }
          })}><FontAwesomeIcon icon={faArrowLeft} /> Voltar</Button>
          <div>
            {
              pdf
                ? <Button color="danger text-light" onClick={handlePrint} ><FontAwesomeIcon icon={faFilePdf} /> Gerar PDF</Button>
                : <></>
            }
            {xls
              ? <Button className="ms-4" color="success text-light" ><FontAwesomeIcon icon={faFileExcel} /> Gerar Excel</Button>
              : <></>
            }

          </div>

        </div>
        <div id="relatorio" className="relatorio w-100 " style={{lineHeight: "150%"}} ref={ref}>
          <div className={"mb-0 header"} id="cabecalho">
            <div className="print mb-2 mx-2 d-flex align-items-center justify-content-between">
              <p>Emitido por: {usuario.nome}</p>
              <p>Data de emissão: {moment().format("DD/MM/YYYY")}</p>
            </div>
            {setupVariavel?.logoTipo &&
              <div className="d-flex align-items-center justify-content-center">
                <img src={"data:image/png;base64," + setupVariavel?.logoTipo}  style={{ maxWidth: '80%'}}  />
              </div>
            }
            <div className="topo mb-4">
              {title
                ?
                <h2 className="text-center fw-bold">{title}</h2>
                :
                <></>}
              <p className="text-center">
                {initialDate
                  ? <p><span className="fw-bold">Período de <span className="fw-normal">{moment(initialDate).format("DD/MM/YYYY")}</span>  até <span className="fw-normal">{finalDate ? moment(finalDate).format("DD/MM/YYYY") : "Hoje"}</span></span></p>
                  : <></>}
                {!initialDate && finalDate
                  ? <span className="me-1"><span className="ps-1 fw-bold">Data Final: <span className="fw-normal">{finalDate ? moment(finalDate).format("DD/MM/YYYY") : "Hoje"}</span></span></span>
                  : <></>}
                {tipoMapa
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Tipo relatório:</span> {tipoMapa}</span>
                  : <></>}
                {agrupamento
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Agrupamento:</span> {agrupamento}</span>
                  : <></>}
                {modalidadeColeta
                  ? <span className={finalDate && !initialDate ? "border-start border-dark ps-1" : "ps-1 ms-2 me-1"}><span className="fw-bold">Modalidade de coleta:</span> {modalidadeColeta}</span>
                  : <></>}
                {gerador
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Gerador:</span> {gerador}</span>
                  : <></>}
                {transportador
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Transportador:</span> {transportador}</span>
                  : <></>}
                {destinoFinal
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Destino Final:</span> {destinoFinal}</span>
                  : <></>}
                {ramoAtividade
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Ramo de atividade:</span> {ramoAtividade}</span>
                  : <></>}
                {localidades
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Localidades:</span> {localidades}</span>
                  : <></>}
                {regional
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Regional:</span> {regional}</span>
                  : <></>}
                {status
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Status:</span> {status}</span>
                  : <></>}
                {cidades
                  ? <span className="me-1"><span className="border-start border-dark ps-1 fw-bold">Cidades:</span> {cidades}</span>
                  : <></>}
                {idMTR
                  ?
                  <div className='bw-bold d-flex justify-content-center align-items-start flex-column mb-1 px-3' style={{ color: "#666" }}>
                    <h5>{setupVariavel?.descricaoDocumentoColeta?.toUpperCase()}</h5>
                    <div className='d-flex gap-3'>
                      <span className='fw-regular'><span className="fw-bold">Nº:</span> {idMTR}</span>
                    </div>
                  </div>
                  : <></>}
                {statusMTR
                  ?
                  <div className='bw-bold d-flex justify-content-center align-items-start flex-column mb-1 px-3'>
                    <div className='d-flex gap-3'>
                      <span className='fw-regular'><span className="fw-bold">Status:</span> {statusMTR} </span>
                    </div>
                  </div>
                  : <></>}
              </p>
            </div>
          </div>
          <div className={"body w-100"} id="cabecalho">
            <Routes>
              {routes.map((prop, key) => {
                const Screen = prop.component;
                if (prop.layout !== '/empty') {
                  return <></>;
                }
                return (
                  <Route
                    path={prop.path}
                    element={<Screen />}
                    key={key}
                  />
                );
              })}
            </Routes>
          </div>
        </div>
      </Container >
    </div >

  )

}